import React, { useEffect, useState } from 'react';
import ArrowDownIcon from './ArrowDownIcon';
import ArrowUpIcon from './ArrowUpIcon';
import { motion } from 'motion/react';
import avatars from './../config/avatars';
import {
  STICKY_BUTTON_CENTER,
  STICKY_BUTTON_INSET,
  STICKY_BUTTON_SIZE,
} from './../config/constants';
import { CurrentUserResourceType } from './../resources/Auth/CurrentUser';
import { PopWrapper } from './PopWrapper';

export let SCROLLED_OFF_TOP = 'SCROLLED_OFF_TOP' as const;
export let SCROLLED_OFF_BOTTOM = 'SCROLLED_OFF_BOTTOM' as const;

export let ScrolledOffUser = ({
  shouldShow,
  offScreenDirection,
  onRequestScrollTo,
  currentUserRankIndex,
  currentUser,
}: {
  currentUser: CurrentUserResourceType;
  shouldShow: boolean;
  currentUserRankIndex: number;
  onRequestScrollTo: () => void;
  offScreenDirection?: typeof SCROLLED_OFF_TOP | typeof SCROLLED_OFF_BOTTOM;
}) => {
  let positionKey = currentUser.prefersLeftHandMode ? 'left' : 'right';
  let ArtworkComponent =
    avatars[currentUser.avatarId || 'AVATAR_0'].ArtworkComponent;

  let [persistentOffScreenDirection, setPersistentOffScreenDirection] =
    useState(offScreenDirection);
  useEffect(() => {
    if (offScreenDirection) setPersistentOffScreenDirection(offScreenDirection);
  }, [offScreenDirection]);

  return (
    <motion.div
      className="absolute z-10 flex items-center justify-center"
      style={{
        bottom: STICKY_BUTTON_INSET + STICKY_BUTTON_SIZE + 24,
        x: currentUser.prefersLeftHandMode ? '-50%' : '50%',
      }}
      initial={{ opacity: 0, [positionKey]: -60 }}
      animate={{
        opacity: shouldShow ? 1 : 0,
        [positionKey]: shouldShow ? STICKY_BUTTON_CENTER : -60,
      }}
      transition={{ type: 'spring', stiffness: 340, damping: 32 }}
      onClick={onRequestScrollTo}
    >
      <PopWrapper>
        <div className="relative flex items-center justify-center rounded-full border-4 border-neutral-100 bg-neutral-100 shadow-xl">
          <ArtworkComponent
            className="h-14 w-14"
            backgroundColor={currentUser.avatarBackgroundHex || undefined}
          />
          <div
            className={`bg-neutral-0 absolute flex items-center justify-center rounded-full border-2 px-1.5 py-px text-purple-900 shadow-md ${
              currentUser.prefersLeftHandMode
                ? 'translate-x-1/2'
                : '-translate-x-1/2'
            }`}
            style={{
              // Position badge centered on the circle's edge.
              // Avatar: h-14 (56px) + border-4 (8px) = 64px diameter, radius = 32px.
              // Badge center is 12px from the top → 20px from center vertically.
              // Circle edge x at that y: sqrt(32² - 20²) ≈ 25px from center → 32 + 25 = 57px.
              top: -14,
              [currentUser.prefersLeftHandMode ? 'right' : 'left']: Math.round(
                32 + Math.sqrt(32 * 32 - 20 * 20),
              ),
            }}
          >
            {persistentOffScreenDirection === SCROLLED_OFF_TOP && (
              <ArrowUpIcon className="h-3.5 w-3.5 text-rose-500" />
            )}
            {persistentOffScreenDirection === SCROLLED_OFF_BOTTOM && (
              <ArrowDownIcon className="h-3.5 w-3.5 text-rose-500" />
            )}
            <span className="text-sm font-semibold">
              {currentUserRankIndex + 1}
            </span>
          </div>
        </div>
      </PopWrapper>
    </motion.div>
  );
};
